// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3l2dK","errorLogs":"styles_errorLogs__3zJu0"};